import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useApplication');

    return {
        APPLICATION_NAME_DUPLICATE_ERROR: t('applicationNameDuplicateError'),
        CONNECTION_ERROR: t('connectionError'),
        SAVE_FAILED: t('saveFailed')
    };
};

export default useTranslation;
